import QTable from 'quasar/src/components/table/QTable.js';

export function getPredefinedAnswerInAdmin(): QTable['columns'] {
  return [
    // {
    //   name: 'id',
    //   field: 'id',
    //   label: 'شناسه',
    //   align: 'left',
    //   style:'max-width:50px;'
    // },
    {
      name: 'text',
      field: 'text',
      label: 'متن',
      align: 'left',
      style: 'max-width:400px;'
    },
    {
      name: 'actions',
      field: 'actions',
      label: '',
      align: 'left'
    }
  ]
}


